/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { StoreActions } from '../../../core/context/store';
import { AppConfig } from '../../../core/config';
import { ApiService } from '../../../core/services';
import { SessionConfigItem, Lab, Session, SessionProps, ExperimentConfiguration } from '../models';
import { AppEnvironments } from '../../../core/constants';

export const resetSessionConfiguration =
  (sessionId: number, callbackSuccess: () => void = () => null) =>
  async (actions: StoreActions<number>): Promise<void> => {
    try {
      await ApiService.post(`v1/sessions/${sessionId}/anatomical-model-tissues/reset`);
      await ApiService.post(`v1/sessions/${sessionId}/configuration/reset`);
      callbackSuccess();
    } catch (err: any) {
      actions.setError(err.message);
    }
  };

export const updateSessionConfiguration =
  (
    sessionId: number,
    configurations: ExperimentConfiguration[],
    configurationName: string,
    value: string | number,
    callbackSuccess: () => void = () => null
  ) =>
  async (actions: StoreActions<SessionConfigItem>): Promise<void> => {
    try {
      const configurationId = configurations.find((config) => config.name === configurationName)?.id ?? 0;
      const sessionConfig: SessionConfigItem = { configurationId, value };
      await ApiService.post(`v1/sessions/${sessionId}/configuration`, sessionConfig);
      callbackSuccess();
    } catch (err: any) {
      actions.setError(err.message);
    }
  };

export const fetchSessionConfiguration =
  (sessionId: number, callbackSuccess: () => void = () => null) =>
  async (actions: StoreActions<any>): Promise<void> => {
    try {
      const response = await ApiService.get<any, any>(`v1/sessions/${sessionId}/configuration`);
      callbackSuccess();
      actions.setValue(response.data);
    } catch (err: any) {
      actions.setError(err.message);
    }
  };

export const closeSession =
  (sessionId: number, callbackSuccess?: () => void) =>
  async (actions: StoreActions<SessionConfigItem | SessionProps | Session>): Promise<any> => {
    actions.startLoading();
    try {
      await ApiService.put(`v1/sessions/${sessionId}/close`);
      if (callbackSuccess) {
        callbackSuccess();
      }
    } catch (err: any) {
      if (callbackSuccess) {
        callbackSuccess();
      }
      actions.setError(err.message);
    }
  };

const createLabSession =
  (labId: Lab['id'], _history: unknown, instanceId?: string, callbackSuccess: () => void = () => null) =>
  async (actions: StoreActions<Session>): Promise<void> => {
    try {
      actions.startLoading();
      const bodyRest =
        instanceId &&
        instanceId !== '' &&
        (AppConfig.env === AppEnvironments.DEVELOPMENT ||
          AppConfig.env === AppEnvironments.INTEGRATION ||
          AppConfig.env === AppEnvironments.STAGING)
          ? { instanceId }
          : {};
      const response = await ApiService.post<Session, any>(`v1/sessions/`, {
        labId,
        ...bodyRest,
        enableCenSol: true,
      });
      actions.setValue(response.data);
      if (callbackSuccess) {
        callbackSuccess();
      }
      // history.push(`/session/${response.data.id}/simulator`);
      window.open(`/session/${response.data.id}/simulator`, '_blank')?.focus();
    } catch (err: any) {
      actions.setError(err.message);
    }
  };

export const useCreateLabSession = () => {
  return (labId: Lab['id'], _history: unknown, instanceId?: string, callbackSuccess: () => void = () => null) =>
    createLabSession(labId, _history, instanceId, callbackSuccess);
};

export const resetSession =
  (sessionId: number) =>
  async (actions: StoreActions<any>): Promise<void> => {
    try {
      await ApiService.put<any, any>(`v1/sessions/${sessionId}/reset`);
    } catch (err: any) {
      actions.setError(err.message);
    }
  };
